module.exports = __webpack_public_path__ + "img/qrcode_zx.8edb7b0c.png";